import { IContent } from 'json-as-xlsx';
import { GridOptions } from 'ag-grid-community';
import { DirectSalesMediaType, DirectSalesMediaTypeLabel } from 'components/common/types/DirectSalesCampaign.types';

export const DESC_FIRST_SORTING_ORDER: GridOptions['sortingOrder'] = ['desc', 'asc'];

export const formatMediaTypeLabels = (types: DirectSalesMediaType[]): string =>
  types.map((type) => DirectSalesMediaTypeLabel[type]).join(', ');

export const TABLE_EXPORT_COLUMNS = [
  {
    label: 'Status',
    value: 'campaignStatus',
  },
  {
    label: 'Campaign name',
    value: 'campaignName',
  },
  {
    label: 'ID',
    value: (row: IContent) => row.userVisibleId || row.id,
  },
  {
    label: 'Media type',
    value: (row: IContent) => {
      const types = row.campaignMediaTypes as unknown as DirectSalesMediaType[];
      if (!types?.length) return '';
      return formatMediaTypeLabels(types);
    },
  },
  {
    label: 'From',
    value: 'startDate',
  },
  {
    label: 'To',
    value: 'endDate',
  },
  {
    label: 'Created date',
    value: 'createdAt',
  },
  {
    label: 'Updated date',
    value: 'updatedAt',
  },
  {
    label: 'Sales team',
    value: 'salesTeam',
  },
  {
    label: 'Sales person',
    value: 'salesPerson',
  },
  {
    label: 'Admin person',
    value: 'adminPerson',
  },
  {
    label: 'Advertiser',
    value: 'advertiser',
  },
  {
    label: 'Brand',
    value: 'brand',
  },
  {
    label: 'Product category',
    value: 'productCategory',
  },
  {
    label: 'Agency',
    value: 'agency',
  },
  {
    label: 'Specialist',
    value: 'specialist',
  },
  {
    label: 'Updated by',
    value: 'updatedBy',
  },
  {
    label: 'Drop date',
    value: 'dropDate',
  },
  {
    label: 'Created by',
    value: 'createdBy',
  },
];
